// The numbers a workout post leads with: duration, exercise count, heart rate,
// power, top load, RPE.
//
// Lives here rather than in either caller because the feed card and the
// full-plan dialog show the same row, and an icon table that exists twice is
// one that goes stale in one of the copies. summariseWorkoutPost decides which
// metrics a post has; this decides how they look.

import React from "react";
import { Clock, Dumbbell, HeartPulse, Zap, Weight, Gauge } from "lucide-react";
import { cn } from "lib/utils";

// Keyed by the `icon` slot summariseWorkoutPost emits, so a new metric can't
// arrive without one — the Clock fallback below is a safety net, not a default.
const METRIC_ICONS = {
  clock: Clock,
  dumbbell: Dumbbell,
  hr: HeartPulse,
  power: Zap,
  load: Weight,
  effort: Gauge,
};

const MetricChips = ({ metrics, className }) => {
  if (!metrics || metrics.length === 0) return null;

  return (
    <div
      className={cn(
        "flex flex-wrap gap-x-3 gap-y-1 text-xs text-muted-foreground",
        className,
      )}
    >
      {metrics.map((metric) => {
        const Icon = METRIC_ICONS[metric.icon] || Clock;
        return (
          <span key={metric.key} className="flex items-center gap-1 tabular-nums">
            <Icon className="h-3 w-3 flex-shrink-0" />
            {metric.label}
          </span>
        );
      })}
    </div>
  );
};

export default MetricChips;
